import React, { useEffect, useState } from "react";
import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";
import apiService from "../utils/apiService";

const SwaggerDocs = () => {
  const [swaggerJson, setSwaggerJson] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchSwaggerDocs = async () => {
      try {
        const swaggerData = await apiService.get("api-docs", setError);
        setSwaggerJson(swaggerData);
      } catch (err) {
        console.error("Error fetching Swagger docs:", err.message);
        // Error handling is already managed by apiService
      }
    };

    fetchSwaggerDocs();
  }, []);

  if (error) {
    return <p style={{ color: "red" }}>{error}</p>;
  }

  if (!swaggerJson) {
    return <p>Loading Swagger documentation...</p>;
  }

  return <SwaggerUI spec={swaggerJson} />;
};

export default SwaggerDocs;
